import axios from 'axios';

export const provinces = ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
  'Newfoundland and Labrador', 'Nova Scotia', 'Northwest Territories', 'Nunavut', 'Ontario', 'Prince Edward Island',
  'Quebec', 'Saskatchewan', 'Yukon'];

export const Country = {
  Canada: 'canada',
  UnitedStates: 'unitedStates'
};

function getIp() {
  return axios.get('https://api.ipgeolocation.io/getip');
}

export function getGeo() {
  return getIp()
    .then(r => axios.get(`https://api.ipgeolocation.io/ipgeo?ip=${r.data.ip}`)
      .then(response => response.data));
}
